var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable @typescript-eslint/naming-convention */
import api from '@utils/axios';
import { apiInternalInspectionDocumentsPath } from '../../../../../routes';
export function getSubcontractorPdfDocuments(inspectionId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield api.get(apiInternalInspectionDocumentsPath(inspectionId, {
            format: 'json',
            show_on_report_only: 'true'
        }));
        return data.documents
            .filter((doc) => doc.pdf)
            .map((doc) => ({
            id: doc.id,
            fileName: doc.file_name,
            downloadUrl: doc.url,
            showOnReport: doc.show_on_report
        }));
    });
}
